import styled, {keyframes} from 'styled-components';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const body = styled.div`
    ${dFlexColumn}
    gap: var(--space-lg);
    padding: var(--space-sm) var(--space-xl);
`;

export const mapWrap = styled.div`
    position: relative;
    width: 100%;
`;

export const map = styled.div`
    ${dFlexColumn}
    align-items: center;
    width: 100%;

    svg {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 260px;
        display: block;
    }

    svg [data-mine] {
        cursor: pointer;
    }

    svg [data-stage] {
        fill: var(--primitive-gray-300);
        stroke: var(--primitive-gray-300);
    }
`;

const tipIn = keyframes`
    from {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.9);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }
`;

const tipWiggle = keyframes`
    0%, 100% {
        transform: translate(-50%, -50%) scale(1);
    }
    20% {
        transform: translate(calc(-50% - 3px), -50%) scale(1.04);
    }
    40% {
        transform: translate(calc(-50% + 3px), -50%) scale(1.04);
    }
    60% {
        transform: translate(calc(-50% - 2px), -50%) scale(1.02);
    }
    80% {
        transform: translate(-50%, -50%) scale(1);
    }
`;

export const tip = styled.div`
    position: absolute;
    z-index: 2;
    transform: translate(-50%, -50%);
    background: var(--primitive-gray-700);
    color: var(--primitive-white, #fff);
    font-size: var(--font-size-body-small);
    white-space: nowrap;
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--border-radius-border-radius-md);
    pointer-events: none;
    animation: ${tipIn} 0.28s cubic-bezier(0.34, 1.6, 0.64, 1), ${tipWiggle} 1s ease-in-out 0.4s;

    &::before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: calc(50% + var(--tip-arrow, 0px));
        width: 10px;
        height: 10px;
        background: inherit;
        transform: translateX(-50%) rotate(45deg);
        border-radius: 1px;
    }
`;
